import { DraftConfiguration, DraftConfigurationTextStyle, DraftState, Point } from '@/types';
import { isDefined } from '@/utils/isDefined';
import { isTemplateAdminMode } from '@/utils/params';
import { getBendingTextSize } from '@/utils/text/getBendingTextSize';
import { getTextSize } from '@/utils/text/getTextSize';
import { updateTextCoordinates } from '@/utils/text/updateTextCoordinates';
import {
  isDraftBendingTextConfiguration,
  isDraftConfigurationWithText,
  isDraftPlaceholderTextConfiguration,
} from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { updatePlaceholderSize } from './helper/updatePlaceholderSize';

export const setTextStyleAction =
  (
    { cid }: DraftConfiguration,
    textStyle: DraftConfigurationTextStyle,
    offset: Point | undefined,
    {
      rotation,
      scale,
    }: {
      rotation?: number;
      scale?: number;
    } = {}
  ) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftConfigurationWithText(configuration)) {
      const text = configuration.text;
      text.style = textStyle;

      if (offset) {
        configuration.offset = offset;
      }
      if (isDefined(rotation)) {
        // rotation can be 0
        configuration.rotation = rotation;
      }
      if (scale) {
        // scale should never be 0
        configuration.scale = scale;
      }

      updateTextCoordinates(text);
      configuration.size = isDraftBendingTextConfiguration(configuration)
        ? getBendingTextSize(text)
        : getTextSize(text);
      if (isDraftPlaceholderTextConfiguration(configuration) && isTemplateAdminMode()) {
        updatePlaceholderSize(configuration);
      }
    }
  };
